import {z} from 'zod';

/**
 * Container schema for PebblePlot graphs
 * Allows customization of visual container properties
 */
export const pebbleplotContainerSchema = z
  .object({
    width: z.union([z.string(), z.number()]).optional(), // CSS width value (e.g., "100%", "500px", or number)
    height: z.union([z.string(), z.number()]).optional(), // CSS height value (e.g., "200px", "auto", or number)
    backgroundColor: z.string().optional(), // CSS background color (e.g., "#ffffff", "rgba(0,0,0,0.1)", "primary.main")
    border: z.string().optional(), // CSS border value (e.g., "1px solid #000000", "2px dashed red")
  })
  .optional();

export type PebblePlotContainer = z.infer<typeof pebbleplotContainerSchema>;
